import React, { Component } from "react";
import { connect } from "react-redux";

//IMPORT COMPONENT
import Menu          from "../Components/component_Menu";
import Loader        from "../Components/component_Loader";
import ErrorMessage  from "../Components/component_MsgError";
import GoToLogin     from "../Components/component_GoToLogin";
import InputIcon     from "../Components/component_IconInput";
import ConfirmDialog from "../Components/component_ConfirmDialog";
import FilterChip    from "../Components/component_FilterChips";
import BuyVersion    from "../Components/component_BuyVersion";
import SGButtonsBar  from "../Components/component_SGButtonsBar";
//COMPONENTI MATERIAL UI
import Popover, { PopoverAnimationVertical } from "material-ui/Popover";
import { Grid, Row, Col }                    from 'react-material-responsive-grid';
import MenuItem                              from "material-ui/MenuItem";
import { RadioButton, RadioButtonGroup }     from "material-ui/RadioButton";
import RaisedButton                          from "material-ui/RaisedButton";
import Toggle                                from 'material-ui/Toggle';
import Dialog                                from 'material-ui/Dialog';
import SelectField                           from "material-ui/SelectField";
import DatePicker                            from "material-ui/DatePicker";
import TextField                             from "material-ui/TextField";
import { Table, TableHeader, TableHeaderColumn, TableBody, TableRowColumn, TableRow, TableFooter } from "material-ui/Table";
//ICON
import IconArrowUp   from "material-ui/svg-icons/navigation/arrow-drop-up";
import IconArrowDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import IconFilter    from "material-ui/svg-icons/content/filter-list";
import IconEdit      from "material-ui/svg-icons/editor/mode-edit";
import IconAdd       from "material-ui/svg-icons/content/add";
import IconDelete    from "material-ui/svg-icons/action/delete";
import IconShow      from "material-ui/svg-icons/image/remove-red-eye";
import IconRefresh   from "material-ui/svg-icons/navigation/refresh";
//TIME
import Moment from "react-moment";
import momentformat from "moment";
//ACTION
import { getListaAziende, orderListaAziende, setAzienda } from "../Actions/Action_ServiceRequest_Azienda";
import { getHoldingList } from "../Actions/Action_ServiceRequest_Holding";
import { getUserInfo } from "../Actions/Action_Authentication";
//Utils
import * as ROLES  from "../Utils/Roles_Types.js";
import * as STYLES from "../Utils/Styles.js";
import { checkEmail, checkTelephoneNumber, checkUserLanguage, checkPivaForm, checkCapForm, checkNull } from "../Utils/Check_Value";
import { LABEL_PAGE_Company, LABEL_Required, LABEL_Filters, LABEL_Deleted, LABEL_Delete, LABEL_Confirm, LABEL_Cancel, LABEL_DIALOG_DELETE_Body,  LABEL_Filter_OnlyActive, LABEL_Filter_OnlyDeleted, 
         LABEL_Name, LABEL_Piva, LABEL_Address, LABEL_City, LABEL_Phone, LABEL_Email, LABEL_District, LABEL_Cap,
         LABEL_WebPage, LABEL_Enter_Name, LABEL_Enter_Piva, LABEL_Enter_Address, LABEL_Enter_City, LABEL_Enter_Phone, LABEL_CompanyDetails,
         LABEL_Enter_Email, LABEL_Enter_District, LABEL_Enter_Cap, LABEL_Enter_WebPage,LABEL_Filter_Either, LABEL_DIALOG_CompanyNew, LABEL_DIALOG_CompanyModify , LABEL_DIALOG_CompanyDetails, LABEL_Company } from "../Utils/Strings/Labels";

var TIMER = null;
const USERINFO = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERIDHOLDING = USERINFO == null ? null: USERINFO.Holding == null ? null : USERINFO.Holding.ID;
const USERLANGUAGE  = checkUserLanguage(USERINFO);
const CANUSEPAGE    = !(!!USERINFO) ? false :  !(USERINFO.Role.ID === ROLES.ACCOUNT_FREE_ID || USERINFO.Role.ID === ROLES.ACCOUNT_PRO_ID);

const styles = {
  propContainer: {
    width: 200,
    overflow: "hidden",
    margin: "20px auto 0"
  },
  filterDialog: {
    width: "100%",
    maxWidth: "none"
  },
  filterRow: {
    marginBottom: "20px"
  }
};

var emptyAziendaModel = {
  ID: null,
  Nome: null, 
  Piva : null,
  Indirizzo : null, 
  Citta : null, 
  Provincia: null,
  Cap : null,
  Telefono: null, 
  Email: null, 
  PaginaWeb : null,
  Holding : {
    ID : null
  },
  Azienda : {
    ID : null
  }
};

class Aziende extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //Table
      fixedHeader         : true,
      fixedFooter         : true,
      stripedRows         : false,
      showRowHover        : true,
      selectable          : true,
      multiSelectable     : false,
      enableSelectAll     : false,
      deselectOnClickaway : false,
      showCheckboxes      : false,
      height              : '700px',
      selectedList        : [],
      selectedObj         : {},
      //SORT
      ordinaPer : null,
      //FILTER
      filter : {
        Nome       : null,
        Citta      : null,
        Provincia  : null,
        Piva       : null,
        Indirizzo  : null,
        Cap        : null,
        Cancellata : null,
        Telefono   : null,
        Email      : null,
        IDHolding  : USERIDHOLDING,
        Cancellata : false
      },
      filterHolding : {
        ID : null,
        Nome : null,
        Descrizione : null,
        DataInizioScadenza : null,
        DataFineScandenza : null
      },
      filterDialog : {
        opened : false,
        data : null //Lo utilizzo per salvare i movimenti nella dialog cosi che se vengono annullati rimane tutto come prima
      },
      //Modal per aggiungere o modificare
      showAddModify : {
        opened : false,
        data   : JSON.parse(JSON.stringify(emptyAziendaModel)),
        modify : true
      },
      filterChipsList : []
    }
  }

  isSelectedRow      = index => this.state.selectedList.indexOf(index) !== -1;
  handleRowSelection = row   => this.setState({ selectedList : row , selectedObj : this.props.aziendeList[row]})

  setTimerForText = () => {
    if(TIMER != null)
      clearTimeout(TIMER);
    TIMER = setTimeout(() => {
      this.props.dispatch(getListaAziende(this.state.filter));
    }, 500);
  };

  //Per intercettare il cambio di filtri testuali
  handleOnFilterTextChange = (value, position, label) => {
    var filterChips = this.state.filterChipsList;
    var filter = this.state.filter;
    filter[position] = value;
    filterChips[position] = {position : position, value : value, label : label };
    this.setTimerForText();
    this.setState({ filter : filter, filterChipsList : filterChips});
  };

  handleOrderChange = (event, index, value) => {
    this.setState({ordinaPer : value});
    this.props.dispatch(orderListaAziende(this.props.aziendeList, value));
  };
  handleChangeHolding = (event, index, value) => {
    var selectedHolding = this.state.filter;
    selectedHolding.IDHolding = value;
    this.setState({ filter: selectedHolding });
    this.props.dispatch(getListaAziende(this.state.filter));
  };

  handleDeleteButton = () => this.setState({showDeleteDialog: true});

  _deleteRow = () =>{
    if (this.state.selectedList[0] > this.props.aziendeList.length) {
      this.setState({ selectedList: [] });
      return;
    }
    var deletedAzienda = this.props.aziendeList[this.state.selectedList[0]];
    deletedAzienda.Cancellata = {
     Cancellata : true
    };
    if (this.state.selectedList[0] == this.props.aziendeList.length -1) // se era l'ultimo
      this.setState({ selectedList: [] });
    this.setState({ showDeleteDialog: false });
    this.props.dispatch(setAzienda(deletedAzienda));
    setTimeout( () => this.props.dispatch(getListaAziende(this.state.filter)), 150 );
  };

  //FILTER DIALOG
  handleOpenFilterDialog = () => {
    var filterDialog = this.state.filterDialog;
    filterDialog.opened = true;
    filterDialog.data = JSON.parse(JSON.stringify(this.state.filter));
    filterDialog.data.Modificabile = filterDialog.data.Modificabile === null ? -1 : Number(filterDialog.data.Modificabile);
    filterDialog.data.Obbligatorio = filterDialog.data.Obbligatorio === null ? -1 : Number(filterDialog.data.Obbligatorio);
    filterDialog.data.Cancellato   = filterDialog.data.Cancellato   === null ? -1 : Number(filterDialog.data.Cancellato);
    this.setState({filterDialog : filterDialog});
  };
  handleCloseFilterDialog = () => {
    var filterDialog    = this.state.filterDialog;
    filterDialog.opened = false;
    filterDialog.data   = null;
    this.setState({filterDialog : filterDialog});
  };
  handleCloseFilterDialogWithSave = () => {
    var filterDialog               = this.state.filterDialog;
    filterDialog.opened            = false;
    filterDialog.data.Modificabile = filterDialog.data.Modificabile == -1 ? null : !!filterDialog.data.Modificabile;
    filterDialog.data.Obbligatorio = filterDialog.data.Obbligatorio == -1 ? null : !!filterDialog.data.Obbligatorio;
    filterDialog.data.Cancellato   = filterDialog.data.Cancellato   == -1 ? null : !!filterDialog.data.Cancellato;
    this.setState({filter : filterDialog.data});
    this.props.dispatch(getListaAziende(filterDialog.data));
  };
  //Funzione per l'evento nel toggle dei filtri
  handleFilterToggle = (event, toggle, position) => {
    var filterDialog = this.state.filterDialog;
    filterDialog.data[position] = toggle;
    this.setState({filterDialog : filterDialog});
  };

  //Dialog aggiunta modifica campo personalizzato
  handleOpenAddModifyOnlyRead = () => {
    this.handleOpenAddModify(true);
  }
  handleOpenAddModify = (modify = false) => {
    var showAddModify = this.state.showAddModify;
    showAddModify.opened = true;
    if(this.state.selectedList.length === 1){
      var x = this.props.aziendeList[this.state.selectedList[0]];
      showAddModify.data = JSON.parse(JSON.stringify(this.props.aziendeList[this.state.selectedList[0]]));
    }else{
      showAddModify.data = JSON.parse(JSON.stringify(emptyAziendaModel));
      showAddModify.data.Holding.ID = this.state.filter.IDHolding;
    }
    showAddModify.modify = modify;
    this.setState({showAddModify : showAddModify});
  };
  handleCloseAddModify = () => {
    var showAddModify = this.state.showAddModify;
    showAddModify.opened = false;
    this.setState( { showAddModify : showAddModify } );
  };
  handleCloseAddModifyWithSave = () => {
    //Controllo i campi
    var flag = true;
    var showAddModify = this.state.showAddModify;
    var _required = LABEL_Required[USERLANGUAGE];
    var data = showAddModify.data;
    //NOME
    if(checkNull(data.Nome)){
      data.msgErrorNome = _required;
      flag = false;
    }else data.msgErrorNome = "";
    //CITTA
    if(checkNull(data.Citta)){
      data.msgErrorCitta = _required;
      flag = false;
    }else data.msgErrorCitta = "";
    //PIVA
    data.msgErrorPiva = checkPivaForm(data.Piva);
      if(data.msgErrorPiva != null) flag = false;
    //PROVINCIA
    if(checkNull(data.Provincia)){
      data.msgErrorProvincia = _required;
      flag = false;
    }else data.msgErrorProvincia = "";
    //INDIRIZZO
    if(checkNull(data.Indirizzo)){
      data.msgErrorIndirizzo = _required;
      flag = false;
    }else data.msgErrorIndirizzo = "";
    //CAP
    data.msgErrorCap = checkCapForm(data.Cap);
      if( data.msgErrorCap != null ) flag = false;
    //HOLDING
    if(data.Holding == null || data.Holding.ID == null) //forzo l'holding (cosi da non perdere traccia del campo aggiunto)
      data.Holding = USERINFO.Holding;

    showAddModify.data = data;
    if(flag){
      showAddModify.opened = false;
      this.props.dispatch(setAzienda(showAddModify.data));//mando al servizio i dati
      setTimeout( () => this.props.dispatch(getListaAziende(this.state.filter)), 150);//ricarico la lista
    }else this.setState( { showAddModify : showAddModify } );
  };
  handleOnChangeAddModifyText = (value, position) => {
    var showAddModify = this.state.showAddModify;
    if(value === null || value.trim() === ""){
      showAddModify.data["msgError"+position] = LABEL_Required[USERLANGUAGE];
    }else showAddModify.data["msgError"+position] = "";
    showAddModify.data[position] = value;
    this.setState( { showAddModify : showAddModify } );
  };

  onDeleteChips = chip => {
    var filterChips = this.state.filterChipsList;
    var filter = this.state.filter;
    filter[chip.position] = null;
    filterChips[chip.position] = null;
    this.setTimerForText();
    this.setState({ filter : filter, filterChipsList : filterChips});
  }

  componentDidMount(){
    if(!CANUSEPAGE) return;
    this.props.dispatch(getUserInfo());
    //se si e' un amministratore is bisogna prima selezionare la holding
    if(this.state.filter.IDHolding === null){
      this.props.dispatch(getHoldingList(this.state.filterHolding));
    }else{
      this.props.dispatch(getListaAziende(this.state.filter));
    }
  };

  //BUTTON BAR

  render() {

    var modifyPermission = USERINFO != null && USERINFO.Role.ID == ROLES.ADMINISTRATOR_IS_ID || USERINFO.Role.ID == ROLES.ADMINISTRATOR_HOLDING_ID;

     //Tasti per la dialog filtri
    const filterDialogAction = [
      <RaisedButton
        label="Annulla"
        primary={false}
        onClick={this.handleCloseFilterDialog}
      />,
      <RaisedButton
        label="Salva"
        primary={true}
        onClick={this.handleCloseFilterDialogWithSave}
      />
    ];

    //Tasti per la dialog aggiungi/modifica
    var addModifyDialogAction = null;

    if(this.state.showAddModify.modify == true){
      addModifyDialogAction = [
      <RaisedButton
        label="Chiudi"
        primary={false}
        onClick={this.handleCloseAddModify}
      />,
    ];
    }else{
      addModifyDialogAction = [
        <RaisedButton
          label="Annulla"
          primary={false}
          onClick={this.handleCloseAddModify}
        />,
        <RaisedButton
          label="Salva"
          primary={true}
          onClick={this.handleCloseAddModifyWithSave}
      />];
    }

    //BUTTON BAR
    var buttonBarList = [];
    if(modifyPermission){
      //AGGIUNGI
      buttonBarList = [{ 
         icon     : <IconAdd />,
         onClick  : this.handleOpenAddModify,
         disabled : this.state.selectedList.length > 0
      },
      //ELIMINA
      {
         icon     : <IconEdit />,
         onClick  : this.handleOpenAddModify,
         disabled : this.state.selectedList.length < 1
      },
      //VISUALIZZA DETTAGLIO
      {
         icon     : <IconShow />, 
         onClick  : this.handleOpenAddModifyOnlyRead, 
         disabled : this.state.selectedList.length < 1 ,
      }]
    }
    buttonBarList.push({
        icon    : <IconRefresh />,
        onClick : () => this.props.dispatch(getListaAziende(this.state.filter))
    })

    let _LABEL_Enter_Name  = LABEL_Enter_Name[USERLANGUAGE];
    let _LABEL_Name        = LABEL_Name[USERLANGUAGE];
    let _LABEL_Piva        = LABEL_Piva[USERLANGUAGE];
    let _LABEL_Enter_Piva  = LABEL_Enter_Piva[USERLANGUAGE];
    let _LABEL_Enter_Phone = LABEL_Enter_Phone[USERLANGUAGE];
    let _LABEL_Phone       = LABEL_Phone[USERLANGUAGE];
    let _LABEL_Email       = LABEL_Email[USERLANGUAGE];
    let _LABEL_Cap         = LABEL_Cap[USERLANGUAGE];
    let _LABEL_City        = LABEL_City[USERLANGUAGE];
    let _LABEL_Address     = LABEL_Address[USERLANGUAGE];
    let _LABEL_District    = LABEL_District[USERLANGUAGE];

    return (<div>
        <Menu dispatch={this.props.dispatch} pageName={LABEL_PAGE_Company[USERLANGUAGE]} Language={USERLANGUAGE}/>
          <Loader isFetching         = {this.props.isFetching}/>
          <ErrorMessage message      = {this.props.errorMessage} />
          <GoToLogin isAuthenticated = {this.props.isAuthenticated}/>
          <BuyVersion 
            visible={!CANUSEPAGE}
            Language={USERLANGUAGE}/>
            <div className="my-body">
            { USERIDHOLDING == null &&
              <SelectField
                  floatingLabelText="Seleziona Holding"
                  value={this.state.filter.IDHolding}
                  onChange={this.handleChangeHolding}>
                    {  this.props.holdingList && this.props.holdingList.map( holding => <MenuItem key={holding.ID} value={holding.ID} primaryText={holding.Nome}/>  ) }
              </SelectField>
            }
            { this.state.filter.IDHolding != null &&
              <div>
                <Grid>
                  <Row style={styles.filterRow}>
                    <Col sm12={6} lg12={3} xl12={3}>
                        <InputIcon
                            icon = {<IconFilter/>} 
                            className="input-label"
                            onChange          = { event => this.handleOnFilterTextChange( event.target.value, "Nome", _LABEL_Name ) }
                            hintText          ={_LABEL_Enter_Name}
                            floatingLabelText ={_LABEL_Name}
                            value             ={this.state.filter.Nome || ""}/>
                    </Col>
                    <Col sm12={6} lg12={3} xl12={3}>
                        <InputIcon
                            icon = {<IconFilter/>} 
                            className="input-label"
                            onChange          = { event => this.handleOnFilterTextChange( event.target.value, "Piva", _LABEL_Piva ) }
                            hintText          = {_LABEL_Enter_Piva}
                            floatingLabelText = {_LABEL_Piva}
                            value             = {this.state.filter.Piva || ""}/>
                    </Col>
                    <Col sm12={6} lg12={3} xl12={3}>
                        <InputIcon
                            icon = {<IconFilter/>} 
                            className="input-label"
                            onChange          = { event => this.handleOnFilterTextChange( event.target.value, "Telefono", _LABEL_Phone ) }
                            hintText          = {_LABEL_Enter_Phone}
                            floatingLabelText = {_LABEL_Phone}
                            value             = {this.state.filter.Telefono || ""}/>
                    </Col>
                    <Col sm12={6} lg12={3} xl12={3}>
                        <InputIcon
                            icon = {<IconFilter/>} 
                            className="input-label"
                            onChange          = { event => this.handleOnFilterTextChange( event.target.value, "Email", _LABEL_Email ) }
                            hintText          = {LABEL_Enter_Email[USERLANGUAGE]}
                            floatingLabelText = {_LABEL_Email}
                            value             = {this.state.filter.Email || ""}/>
                    </Col>
                  </Row>
                  <Row style={styles.filterRow}>
                    <Col sm12={9}></Col>
                    <Col sm12={3}>
                    <SelectField
                          floatingLabelText="Ordina Per"
                          value={this.state.ordinaPer}
                          onChange={this.handleOrderChange}
                        >
                          <MenuItem value={"Cap"}            primaryText={_LABEL_Cap}      rightIcon={<IconArrowUp />}/>
                          <MenuItem value={"CapDESC"}        primaryText={_LABEL_Cap}      rightIcon={<IconArrowDown />}/>
                          <MenuItem value={"Citta"}          primaryText={_LABEL_City}     rightIcon={<IconArrowUp />}/>
                          <MenuItem value={"CittaDESC"}      primaryText={_LABEL_City}     rightIcon={<IconArrowDown />}/>
                          <MenuItem value={"Email"}          primaryText={_LABEL_Email}    rightIcon={<IconArrowUp />}/>
                          <MenuItem value={"EmailDESC"}      primaryText={_LABEL_Email}    rightIcon={<IconArrowDown />}/>
                          <MenuItem value={"Indirizzo"}      primaryText={_LABEL_Address}  rightIcon={<IconArrowUp />}/>
                          <MenuItem value={"IndirizzoDESC"}  primaryText={_LABEL_Address}  rightIcon={<IconArrowDown />}/>
                          <MenuItem value={"Nome"}           primaryText={_LABEL_Name}     rightIcon={<IconArrowUp />}/>
                          <MenuItem value={"NomeDESC"}       primaryText={_LABEL_Name}     rightIcon={<IconArrowDown />}/>
                          <MenuItem value={"Piva"}           primaryText={_LABEL_Piva}     rightIcon={<IconArrowUp />}/>
                          <MenuItem value={"PivaDESC"}       primaryText={_LABEL_Piva}     rightIcon={<IconArrowDown />}/>
                          <MenuItem value={"Provincia"}      primaryText={_LABEL_District} rightIcon={<IconArrowUp />}/>
                          <MenuItem value={"ProvinciaDESC"}  primaryText={_LABEL_District} rightIcon={<IconArrowDown />}/>
                          <MenuItem value={"Telefono"}       primaryText={_LABEL_Phone}    rightIcon={<IconArrowUp />}/>
                          <MenuItem value={"TelefonoDESC"}   primaryText={_LABEL_Phone}    rightIcon={<IconArrowDown />}/>
                        </SelectField>
                    </Col>
                  </Row>
                  <Row>
                    {USERINFO != null && <SGButtonsBar list = {buttonBarList} /> }
                  </Row>
                </Grid>

                <FilterChip
                  list = {this.state.filterChipsList}
                  onDelete = {this.onDeleteChips}
                />

                <Table
                  className       = "shadow"
                  height          = { (window.innerHeight - 500) + "px" }
                  fixedHeader     = { this.state.fixedHeader}
                  fixedFooter     = { this.state.fixedFooter}
                  selectable      = { this.state.selectable}
                  multiSelectable = { this.state.multiSelectable}
                  onRowSelection  = { this.handleRowSelection}
                  >

                  <TableHeader
                      displaySelectAll  = { this.state.showCheckboxes  }
                      adjustForCheckbox = { this.state.showCheckboxes  }
                      enableSelectAll   = { this.state.enableSelectAll }>
                        <TableRow>
                          <TableHeaderColumn tooltip="">{_LABEL_Name +" "+ LABEL_Company[USERLANGUAGE]} </TableHeaderColumn>
                          <TableHeaderColumn tooltip="">{_LABEL_Piva}                     </TableHeaderColumn>
                          <TableHeaderColumn tooltip="">{_LABEL_Address}                  </TableHeaderColumn>
                          <TableHeaderColumn tooltip="">{_LABEL_City}                     </TableHeaderColumn>
                          <TableHeaderColumn tooltip="">{_LABEL_Cap}                      </TableHeaderColumn>
                          <TableHeaderColumn tooltip="">{_LABEL_District}                 </TableHeaderColumn>
                          <TableHeaderColumn tooltip="">{_LABEL_Phone}                    </TableHeaderColumn>
                          <TableHeaderColumn tooltip="">{_LABEL_Email}                    </TableHeaderColumn>
                          <TableHeaderColumn tooltip="">{LABEL_WebPage[USERLANGUAGE]}                  </TableHeaderColumn>
                        </TableRow>
                  </TableHeader>

                  <TableBody
                    displayRowCheckbox  = {this.state.showCheckboxes}
                    deselectOnClickaway = {this.state.deselectOnClickaway}
                    showRowHover        = {this.state.showRowHover}
                    stripedRows         = {this.state.stripedRows}
                  >
                    {
                      this.props.aziendeList.map( (row, index) => (
                      <TableRow key={index} selected={this.isSelectedRow(index)}>
                        <TableRowColumn> { row.Nome}       </TableRowColumn>
                        <TableRowColumn> { row.Piva}       </TableRowColumn>
                        <TableRowColumn> { row.Indirizzo}  </TableRowColumn>
                        <TableRowColumn> { row.Citta}      </TableRowColumn>
                        <TableRowColumn> { row.Cap}        </TableRowColumn>
                        <TableRowColumn> { row.Provincia}  </TableRowColumn>
                        <TableRowColumn> { row.Telefono}   </TableRowColumn>
                        <TableRowColumn> { row.Email}      </TableRowColumn>
                        <TableRowColumn> { row.PaginaWeb == null ? "" : <a href={row.PaginaWeb}>{LABEL_WebPage[USERLANGUAGE]}</a>}  </TableRowColumn>

                      </TableRow>
                      ))
                    }
                  </TableBody>
              </Table>
              </div>
          }

            {/*FILTRI*/}
            <Dialog
              title={LABEL_Filters[USERLANGUAGE]}
              actions={filterDialogAction}
              modal={true}
              contentStyle={styles.filterDialog}
              open={this.state.filterDialog.opened}
            >
              <Grid>
                <Row>
                  <Col sm12={2}>
                    <div className="margin-top-25px">{_LABEL_Piva}</div>
                  </Col>
                  <Col sm12={3} className="line-bottom">
                    <TextField className="input-label"
                            onChange          = { event => this.handleOnFilterTextChange( event.target.value, "Piva" ) }
                            hintText          = {_LABEL_Enter_Piva}
                            floatingLabelText = {_LABEL_Piva}
                            value             = {this.state.filter.Piva == null ? "" : this.state.filter.Piva}/>
                  </Col>
                </Row>
                <Row>
                  <Col sm12={2}>
                    <div className="margin-top-25px">{LABEL_Deleted}</div>
                  </Col>
                  <Col sm12={3} className="line-bottom">
                    <RadioButtonGroup name="shipSpeed" 
                      defaultSelected={this.state.filterDialog.data === null ? -1 : this.state.filterDialog.data.Cancellato}
                      onChange={(event, toggle) => this.handleFilterToggle(event, toggle, "Cancellato")} >
                      <RadioButton value={0}  label={LABEL_Filter_OnlyActive[USERLANGUAGE]} />
                      <RadioButton value={1}  label={LABEL_Filter_OnlyDeleted[USERLANGUAGE]} />
                      <RadioButton value={-1} label={LABEL_Filter_Either[USERLANGUAGE]} />
                    </RadioButtonGroup>
                  </Col>
                </Row>
              </Grid>
            </Dialog>

            <Dialog
              title={this.state.selectedList.length === 0 ? LABEL_DIALOG_CompanyNew[USERLANGUAGE] : this.state.showAddModify.modify ? LABEL_DIALOG_CompanyModify[USERLANGUAGE] : LABEL_CompanyDetails[USERLANGUAGE]}
              actions={addModifyDialogAction}
              modal={true}
              contentStyle={styles.filterDialog}
              open={this.state.showAddModify.opened}
            >
              <Grid>
                <Row>
                  <Col sm12={2}></Col>
                  <Col sm12={3}>
                    <TextField className="input-label"
                      onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Nome")}
                      hintText={_LABEL_Enter_Name}
                      floatingLabelText={_LABEL_Name}
                      fullWidth={true}
                      errorText={this.state.showAddModify.data.msgErrorNome}
                      fullWidth={true}
                      disabled={this.state.showAddModify.modify == true ? true : false}
                      value={ this.state.showAddModify.data.Nome || "" }/>
                  </Col>
                  <Col sm12={2}></Col>
                  <Col sm12={3}>
                    <TextField className="input-label"
                      onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Piva")}
                      hintText={_LABEL_Enter_Piva}
                      floatingLabelText={_LABEL_Piva}
                      errorText={this.state.showAddModify.data.msgErrorPiva}
                      fullWidth={true}
                      disabled={this.state.showAddModify.modify == true ? true : false}
                      value={ this.state.showAddModify.data.Piva || ""}/>
                  </Col>
                  <Col sm12={2}></Col>
                </Row>
                <Row>
                  <Col sm12={2}></Col>
                  <Col sm12={3}>
                    <TextField className="input-label"
                      onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Indirizzo")}
                      hintText={LABEL_Enter_Address[USERLANGUAGE]}
                      floatingLabelText={_LABEL_Address}
                      fullWidth={true}
                      errorText={this.state.showAddModify.data.msgErrorIndirizzo}
                      disabled={this.state.showAddModify.modify == true ? true : false}
                      value={ this.state.showAddModify.data.Indirizzo || ""}/>
                  </Col>
                  <Col sm12={2}></Col>
                  <Col sm12={3}>
                    <TextField className="input-label"
                      onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Citta")}
                      hintText={LABEL_Enter_City[USERLANGUAGE]}
                      floatingLabelText={_LABEL_City}
                      fullWidth={true}
                      errorText={this.state.showAddModify.data.msgErrorCitta}
                      disabled={this.state.showAddModify.modify == true ? true : false}
                      value={ this.state.showAddModify.data.Citta || ""}/>
                  </Col>
                  <Col sm12={2}></Col>
                </Row>
                <Row>
                  <Col sm12={2}></Col>
                  <Col sm12={3}>
                    <TextField className="input-label"
                      onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Cap")}
                      hintText={LABEL_Enter_Cap[USERLANGUAGE]}
                      floatingLabelText={_LABEL_Cap}
                      fullWidth={true}
                      type="number"
                      errorText={this.state.showAddModify.data.msgErrorCap}
                      disabled={this.state.showAddModify.modify == true ? true : false}
                      value={ this.state.showAddModify.data.Cap || ""}/>
                  </Col>
                  <Col sm12={2}></Col>
                  <Col sm12={3}>
                    <TextField className="input-label"
                      onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Provincia")}
                      hintText={LABEL_Enter_District[USERLANGUAGE]}
                      floatingLabelText={_LABEL_District}
                      fullWidth={true}
                      errorText={this.state.showAddModify.data.msgErrorProvincia}
                      disabled={this.state.showAddModify.modify == true ? true : false}
                      value={ this.state.showAddModify.data.Provincia || ""}/>
                  </Col>
                  <Col sm12={2}></Col>
                </Row>
                <Row>
                  <Col sm12={2}></Col>
                  <Col sm12={3}>
                    <TextField className="input-label"
                      onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Telefono")}
                      hintText={_LABEL_Enter_Phone}
                      floatingLabelText={_LABEL_Phone}
                      fullWidth={true}
                      disabled={this.state.showAddModify.modify == true ? true : false}
                      value={ this.state.showAddModify.data.Telefono || ""}/>
                  </Col>
                  <Col sm12={2}></Col>
                  <Col sm12={3}>
                    <TextField className="input-label"
                      onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Email")}
                      hintText={LABEL_Enter_Email[USERLANGUAGE]}
                      floatingLabelText={_LABEL_Email}
                      fullWidth={true}
                      disabled={this.state.showAddModify.modify == true ? true : false}
                      value={ this.state.showAddModify.data.Email || ""}/>
                  </Col>
                  <Col sm12={2}></Col>
                </Row>
                <Row>
                  <Col sm12={2}></Col>
                  <Col sm12={8}>
                    <TextField className="input-label"
                      onChange={event => this.handleOnChangeAddModifyText(event.target.value, "PaginaWeb")}
                      hintText={LABEL_Enter_WebPage[USERLANGUAGE]}
                      floatingLabelText={LABEL_WebPage[USERLANGUAGE]}
                      fullWidth={true}
                      disabled={this.state.showAddModify.modify == true ? true : false}
                      value={ this.state.showAddModify.data.PaginaWeb || ""}/>
                  </Col>
                  <Col sm12={2}></Col>
                </Row>
              </Grid>
            </Dialog>

            <ConfirmDialog 
                title        = { LABEL_Delete[USERLANGUAGE] + " " + LABEL_Company[USERLANGUAGE] + ": "+  (this.state.selectedObj && this.state.selectedObj.Nome) }
                opened       = { this.state.showDeleteDialog}
                confirmLabel = { LABEL_Confirm[USERLANGUAGE]}
                cancelLabel  = { LABEL_Cancel[USERLANGUAGE]}
                onCancel     = { () => this.setState({showDeleteDialog: false}) }
                body         = {LABEL_DIALOG_DELETE_Body[USERLANGUAGE] + "" +  (this.state.selectedObj && this.state.selectedObj.Nome)}
                onConfirm    = { this._deleteRow }/>
            </div>
    </div>);
  }
}

function mapStateToProps(state) {
  const { aziendaReducer } = state;
  const { isFetching, isAuthenticated, aziendeList, errorMessage, holdingList } = aziendaReducer;
  return {
    isFetching,
    aziendeList,
    isAuthenticated,
    errorMessage,
    holdingList
  };
}

export default connect(mapStateToProps)(Aziende);


// WEBPACK FOOTER //
// ./src/Containers/Aziende.js